module.exports = __webpack_public_path__ + "img/171.5eb95f20.png";